import * as React from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import {
  flex,
  width,
  space,
  color,
  height,
  flexWrap,
  maxHeight,
  alignItems,
  flexDirection,
  justifyContent,
} from 'styled-system';

type Props = StyledSystemProps & {
  color?: string;
  backgroundImage?: string;
  children: React.ReactNode;
};

const Container = styled.div`
  ${flex};
  ${space};
  ${color};
  ${width};
  ${height};
  ${flexWrap};
  ${maxHeight};
  ${alignItems};
  ${flexDirection};
  ${justifyContent};
  display: flex;
  box-sizing: border-box;
  background-image: url(${(props: Props) => props.backgroundImage});
  background-size: cover;
`;

const PageWrap: React.FC<Props> = (props: Props) => {
  return <Container {...props}>{props.children}</Container>;
};

PageWrap.defaultProps = {
  p: 0,
  flex: 1,
  width: '100%',
  height: '100%',
  bg: 'paleGrey',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
};

export default PageWrap;



// WEBPACK FOOTER //
// ./src/layouts/PageWrap.tsx